import { render } from "./ThePatientCalendar.vue?vue&type=template&id=5869298e&ts=true"
import script from "./ThePatientCalendar.vue?vue&type=script&lang=ts"
export * from "./ThePatientCalendar.vue?vue&type=script&lang=ts"

import "./ThePatientCalendar.vue?vue&type=style&index=0&id=5869298e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__